module.exports = __webpack_public_path__ + "static/media/600x150.81df415d.png";